import React from "react";
import { ArrowRight, Code2 } from "lucide-react";

const webDevStudies = [
  {
    tag: "Our Approach",
    title: "Technology That Drives Business Growth",
    desc: "Combining modern development practices with user-focused design to build impactful digital products.",
    result: "Fast",
    label: "Delivery",
  },
  {
    tag: "Our Strategy",
    title: "Digital Marketing Backed By Real Data",
    desc: "Every campaign is planned, tracked, and optimized to deliver measurable business outcomes.",
    result: "Smart",
    label: "Targeting",
  },
];
const listItems = [
  "Custom Website Development",
  "CMS Website Development",
  "Landing Page Development",
  "E-Commerce Website",
];

function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] pt-32">
      {/* Background Effects */}{" "}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-orange-500/10 blur-[140px] rounded-full" />{" "}
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />
      {/* Grid Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        {/* Heading */}
        <div className="max-w-4xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[3px] text-orange-500">
            Web Development Services
          </p>

          <h2 className="text-4xl md:text-6xl font-bold leading-tight text-gray-900 dark:text-white">
            Know About Our
            <span className="text-orange-500"> Case Studies</span>
          </h2>

          <p className="mt-6 max-w-3xl text-base text-gray-600 dark:text-gray-300">
            We create responsive websites, custom CMS platforms, landing pages,
            e-commerce stores and business websites that look premium, load fast
            and help generate leads.
          </p>
        </div>

        {/* Content */}
        <div className="mt-8 grid lg:grid-cols-[38%_62%] gap-8 items-start">
          {/* Left */}
          <div>
            <div className="space-y-3">
              {listItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/[0.03] px-5 py-4 transition-all duration-300 hover:border-orange-500/30"
                >
                  <span className="font-medium text-gray-900 dark:text-white">
                    {item}
                  </span>

                  <ArrowRight size={16} className="text-orange-500 shrink-0" />
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="grid md:grid-cols-2 gap-6">
            {webDevStudies.map((item, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-[30px] border border-gray-200 dark:border-white/10 bg-white dark:bg-white/[0.03] p-7 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.08)] dark:hover:shadow-[0_0_50px_rgba(255,255,255,0.05)]"
              >
                <div className="absolute top-0 right-0 w-40 h-40 bg-orange-500/10 blur-3xl rounded-full" />

                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-orange-100 dark:bg-orange-500/10 flex items-center justify-center mb-6">
                    <Code2 className="text-orange-500" size={30} />
                  </div>

                  <span className="inline-flex rounded-full bg-orange-100 dark:bg-orange-500/10 px-3 py-1 text-xs font-semibold text-orange-500">
                    {item.tag}
                  </span>

                  <h3 className="mt-2 text-xl leading-tight font-bold text-gray-900 dark:text-white">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-xs text-gray-600 dark:text-gray-300">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
